import Popover, { positionBounded } from '@components/Popover/Popover';
import { Box, Dialog, DialogHeader } from '@ui-lib';
import { tokens } from '@ui-lib/css';
import { useMemo } from 'react';

import styles from './CardHeader.module.scss';
import { PicturePreviewButton } from './CardHeaderPictures/PicturePreview';
import type { ImageType } from './utilities';

// Convert the rem-valued design-system space token into the pixel number the
// popover positioner expects. Assumes the standard 16px root font-size used
// throughout the app.
const SPACE_LARGE_PX = parseFloat(tokens.space.large) * 16;

function getImageTypes(isPreset?: boolean): ImageType[] {
  return isPreset ? ['logo', 'cover'] : ['profile', 'logo', 'cover'];
}
interface SelectImageTypePopoverProps {
  isPreset?: boolean;
  onClose: () => void;
  onSelect: (type: ImageType) => void;
  show: boolean | undefined;
  targetNode: HTMLElement | undefined;
}

const SelectImageTypePopover: React.FC<React.PropsWithChildren<SelectImageTypePopoverProps>> = ({
  isPreset,
  onClose,
  onSelect,
  show,
  targetNode,
}) => {
  const imageTypes = useMemo(() => getImageTypes(isPreset), [isPreset]);
  return (
    <Popover
      positioner={positionBounded({
        offsetX: SPACE_LARGE_PX,
        xPreference: 'right',
        alignY: 'cover',
        bindToViewport: true,
      })}
      targetNode={targetNode}
      show={!!show}
      onClose={onClose}
      applyModalStyle={false}
      preventOutsideInteraction
      drawFocus={true}
    >
      <div style={{ width: 500, maxWidth: 'calc(100vw - 32px)' }}>
        <Dialog>
          <DialogHeader title="Which image would you like to upload?" onClose={onClose} />
          <Box paddingX="medium" paddingY="large">
            <div className={styles['select-image-type-buttons']}>
              {imageTypes.map((type) => (
                <PicturePreviewButton
                  canLock={false}
                  isLocked={false}
                  required={false}
                  key={type}
                  type={type}
                  onClick={() => onSelect(type)}
                />
              ))}
            </div>
          </Box>
        </Dialog>
      </div>
    </Popover>
  );
};

export default SelectImageTypePopover;
